import React from 'react';
import { FormattedMessage } from 'react-intl';
import { takeEvery, put, call } from 'redux-saga/effects';
import { setCohortList } from 'Workspace/Cohorts/store/actions';
import { pushToast } from 'containers/ToastManager/actions';
import catchErrors from 'utils/commands/catchErrors';
import workspaceService from 'services/WorkspaceService';

import messages from '../messages';
import * as constants from '../constants';

export function* sendRequest(connection) {
  const workspaceCohortList = yield call(connection.fetch.bind(connection), {
    type: constants.RTM_WORKSPACE_COHORT_LIST,
    workspaceId: workspaceService.getSelectedWorkspaceId(),
  });

  if (workspaceCohortList.type === constants.RTM_WORKSPACE_COHORT_LIST_OK) {
    const cohorts = workspaceCohortList.response.cohorts;
    yield put(setCohortList(cohorts));
  } else {
    yield put(pushToast({
      type: 'simple',
      message: <FormattedMessage {...messages.failedWorkspaceCohortListFetch} />,
    }));
  }
}

export default function* (connection) {
  yield takeEvery(constants.COMMAND_WORKSPACE_COHORT_LIST, catchErrors, sendRequest, connection);
}
